/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';
import {
  INVALID_INVOICE_NUM,
  INVOCE_NOT_FOUND,
  INVALID_LONG_ERROR_REGEX
} from '../../../../../../SharedModules/Errors/constantMessageData';
export const dispatchUnfreezeInvoiceData = (data) => {
  return {
    type: actionTypes.UNFREEZE_INVOICE,
    payload: data,
  };
};
export const unfreezeInvoice = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UNFREEZE_INVOICE, values)
    .then((response) => {
      if (
        typeof response?.data === 'string' &&
        INVALID_LONG_ERROR_REGEX.test(response.data)
      ) {
        const msg = `${INVOCE_NOT_FOUND} #${values?.invoiceNumber}`;
        return dispatch(dispatchUnfreezeInvoiceData(msg));
}
      if (
        typeof response?.data === 'string' &&
        response?.data.toLowerCase() === INVALID_INVOICE_NUM.toLowerCase()
      ) {
        const msg = `${INVOCE_NOT_FOUND} #${values?.invoiceNumber}`;
        return dispatch(dispatchUnfreezeInvoiceData(msg));
      } else {
        return dispatch(dispatchUnfreezeInvoiceData(response.data));
      }
    })
    .catch(() => {
      dispatch(dispatchUnfreezeInvoiceData({ error: 'API failed' }));
    });
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_PQR,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_PQR, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturersByPQR(response.date));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrUnfreezeInv: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const setUnfreezeInvoiceData = (data) => ({
  type: actionTypes.SET_REQ_RECORD_MAILING_DATA,
  payload: data,
});

export const setErrorMessages = (data) => ({
  type: actionTypes.SET_ERROR_MESSAES,
  payload: data,
});

export const resetUnfreezeInvoiceStore = () => ({
  type: actionTypes.RESET_UNFREEZE_INVOICE_STORE,
});
